import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl } from "../../../Baseurl";
import AdminSidebar from "../../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../../component/AdminComp/AdminTopbar";
import Swal from "sweetalert2";
import EducationCategoryNavbar from "./EducationCategoryNavbar";

const SubCategoryEducation = () => {
  const [title, setTitle] = useState("");
  const [parentId, setParentId] = useState("");
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    axios.get(`${baseurl}getAllEducationCategories`)
      .then((res) => {
        setCategories(res.data.data || []);
      })
      .catch((err) => {
        console.error("Fetch categories error:", err);
      });
  }, []);

  const generateSlug = (text) => {
    return text.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9\-]/g, "");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        education_title: title,
        is_parent: null,
        has_service: false,
        slug: generateSlug(title),
        parent_id: parentId || null
      };

      await axios.post(`${baseurl}addEducationCategory`, payload);
      Swal.fire("Success", "Education category added!", "success").then(() => window.location.reload());
    } catch (err) {
      console.error("Submit error:", err);
      Swal.fire("Error", "Failed to add category", "error");
    }
  };

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid text-start">

<EducationCategoryNavbar/>

          <div className="crd1">
            <h4 className="mb-3">Add Education Category Under "What We Do"</h4>
            <div className="row">
              <div className="col-md-6">
                <form onSubmit={handleSubmit} className="row g-3 text-start">

                  <div className="col-md-12">
                    <label>What We Do</label>
                    <select
                      className="form-select"
                      required
                      value={parentId}
                      onChange={(e) => setParentId(e.target.value)}
                    >
                      <option value="">-- Select --</option>
                      {categories
                      .filter((cat) => cat.parent_id === null)
                        .sort((a, b) => a.education_title.localeCompare(b.education_title))
                        .map((cat) => (
                          <option key={cat.id} value={cat.id}>
                            {cat.education_title}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className="col-md-12">
                    <label>Category Title</label>
                    <input
                      type="text"
                      className="form-control"
                      required
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                    />
                  </div>

                  <div className="col-12 text-end">
                    <button type="submit" className="btn btn-primary">Add</button>
                  </div>

                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubCategoryEducation;
